import { createAction, props } from '@ngrx/store';
export const setReportCategory = createAction('[Custom PDF Report Builder] Set Report Category', props());
